import '../sass/_index.sass';

import MicroModal from 'micromodal'

import adjustViewport from './function/adjustViewport'

import SmoothScroll from './module/SmoothScroll';
import IntersectionObserverScrollAnima from './module/IntersectionObserverScrollAnima';
// import Accordion from './module/Accordion';
import MemberModal from './module/MemberModal';
import VideoLazy from './module/VideoLazy';
import CopyToClipboard from './module/CopyToClipboard';

// ブレイクポイント
// const bp = {
//   sm: 640,
//   md: 768,
//   lg: 1024,
//   xl: 1280
// };

const init = () => {

  (() => {
    const smoothScroll = new SmoothScroll({
      targets: 'a[href^="#"]',
      fixHeader: '#js-header',
    });
    smoothScroll.init();
  })();

  (() => {
    const intersectionObserverScrollAnima = new IntersectionObserverScrollAnima();
    intersectionObserverScrollAnima.init();
  })();

  (() => {
    MicroModal.init({
      disableScroll: true,
      openTrigger: 'data-drawer-micromodal-trigger',
    });
  })();

  // (() => {
  //   const accordion = new Accordion();
  //   accordion.init();
  // })();

  (() => {
    const memberModal = new MemberModal();
    memberModal.init();
  })();

  (() => {
    const videoLazy = new VideoLazy();
    videoLazy.init();
  })();

  (() => {
    const copyToClipboardArticleURL = new CopyToClipboard({
      copyBtn: '[data-url-copy-btn]',
    });
    copyToClipboardArticleURL.init();
  })();

};

window.addEventListener('DOMContentLoaded', () => {
  adjustViewport();
  init();
});
